(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nsl-counter-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  function initCountdown() {
    const section = document.querySelector('.cc-nexus-clock-announcement-wrapper');
    if (!section) return;

    const targetISO = section.getAttribute('data-target');
    const targetTime = Date.parse(targetISO);

    if (isNaN(targetTime)) {
      console.error('Invalid countdown target:', targetISO);
      return;
    }
    function updateTimer() {
      const now = new Date().getTime();
      let diff = targetTime - now;

      if (diff <= 0) {
        clearInterval(timer);
        document.getElementById('js-clock-days').textContent = "00";
        document.getElementById('js-clock-hours').textContent = "00";
        document.getElementById('js-clock-minutes').textContent = "00";
        document.getElementById('js-clock-seconds').textContent = "00";
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      diff = diff % (1000 * 60 * 60 * 24);
      const hours = Math.floor(diff / (1000 * 60 * 60));
      diff = diff % (1000 * 60 * 60);
      const minutes = Math.floor(diff / (1000 * 60));
      diff = diff % (1000 * 60);
      const seconds = Math.floor(diff / 1000);

      const daysContainer = document.getElementById('days-container');
      const daysBlock = document.getElementById('days-container-block');
      if (days > 0) {
        daysContainer.style.display = 'flex';
        daysBlock.style.display = 'flex';
      } else {
        daysContainer.style.display = 'none';
        daysBlock.style.display = 'none';
      }

      document.getElementById('js-clock-days').textContent = days.toString().padStart(2, '0');
      document.getElementById('js-clock-hours').textContent = hours.toString().padStart(2, '0');
      document.getElementById('js-clock-minutes').textContent = minutes.toString().padStart(2, '0');
      document.getElementById('js-clock-seconds').textContent = seconds.toString().padStart(2, '0');
    }
    updateTimer();
    const timer = setInterval(updateTimer, 1000);
  }

  document.addEventListener('DOMContentLoaded', initCountdown);
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initCountdown);
    document.addEventListener('shopify:section:unload', () => clearInterval(timer));
  }

  } catch(e) { console.error(e); }
})();
})();
